
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return-and-refunds",
      function () {
        return require("private-next-pages/return-and-refunds.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/return-and-refunds"])
      });
    }
  